import React from 'react';
import SubHeader from '../../components/Layout/SubHeader';
import { withRouter } from '../../config/withRouter';
import api from '../../config/api';
import axios from 'axios';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';
class ProductDetailScreen extends React.Component {
    constructor(props) {
        super(props);
        const { slug, sub_slug, product_slug } = this.props.params; // Access the ID from URL parameters        
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            isLoading: true,
            access_token: null,
            slug: slug,
            sub_slug: sub_slug,
            product_slug: product_slug,
            data: {},
            image_gallery: [],
            feature_image: '',
        }
    }

    async componentDidMount() {
        let self = this;
        self.getProductDetailsData(this.state.product_slug)
    }

    getProductDetailsData(slug) {
        const self = this;
        self.setState({ 'isLoading': true })
        axios({
            method: 'GET',
            url: api.ProductDetails + slug + "?lang=" + self.state.lang,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ 'isLoading': false });
            self.setState({ data: ress.data.message.product });
            self.setState({ feature_image: ress.data.message.product.feature_image_url });

            let ImgArr = [ress.data.message.product.feature_image_url];
            ress.data.message.image_gallery.forEach(function (d, i) {
                i = i + 1;
                let json = d.src_url;
                ImgArr.push(json)
            })

            self.setState({ image_gallery: ImgArr, 'isLoading': false })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ ProgressBar: false });
        });
    }

    render() {
        const responsive = {
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            tablet: {
                breakpoint: { max: 1024, min: 480 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            },
            mobile: {
                breakpoint: { max: 480, min: 0 },
                items: 1,
                slidesToSlide: 1 // optional, default to 1.
            }
        };
        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                {!this.state.isLoading ?
                    <>
                        <SubHeader data={{ title: (this.state.data && this.state.data.name) ? this.state.data.name : "-" }} />

                        <div className="productDetailScreen">
                            <main className="product-container">
                                <div className="product-cards">
                                    <div className="info-wrap">
                                        <div className="product-image">
                                            <Carousel
                                                infinite={true}
                                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                                responsive={responsive}
                                                autoPlay
                                            >
                                                {this.state.image_gallery.map((item, i) =>
                                                    <div key={"image_gallery_001_" + i} className="product-wrap">
                                                        <img src={item} alt='' className='product-image' />
                                                    </div>
                                                )}
                                            </Carousel>
                                        </div>
                                        <div className="title-box">
                                            <h2 className="product-name">{(this.state.data && this.state.data.name) ? this.state.data.name : ''}</h2>
                                        </div>
                                        <div className="product-description">
                                            <label>{strings["Description:"]}</label>
                                            <p dangerouslySetInnerHTML={{ __html: (this.state.data && this.state.data.description) ? this.state.data.description : '' }}></p>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </>
                    : null}
            </>
        );
    }
}

export default withRouter(ProductDetailScreen);
